import React from "react";
import BaseButton from "./BaseButton";

/**
 * Save is the primary action on a form, not a "success" state — it wears
 * the app's primary colour rather than the old standalone green.
 */
const BaseSave = (props) => (
  <BaseButton type="primary" { ...props }>
    { props.text || "Save" }
  </BaseButton>
);

export default BaseSave;
